module.exports = __webpack_public_path__ + "img/app-display.637c724c.png";